export enum OrderActionType {
  PAYMENT_METHOD_CHANGE = "CHECKOUT.ACTIONS.PAYMENT_METHOD_CHANGE",
  PAYMENT_PENDING = "CHECKOUT.ACTIONS.PAYMENT.PENDING",
  PAYMENT_SUCCESS = "CHECKOUT.ACTIONS.PAYMENT.SUCCESS",
  PAYMENT_FAILURE = "CHECKOUT.ACTIONS.PAYMENT.FAILURE",
  ORDER_SUCCESS = "CHECKOUT.ACTIONS.ORDER.SUCCESS",
  ORDER_FAILURE = "CHECKOUT.ACTIONS.ORDER.FAILURE",
  ORDER_PENDING = "CHECKOUT.ACTIONS.ORDER.PENDING",
}
